import { Injectable } from '@angular/core';
import { catchError, EMPTY, expand, map, Observable, of, reduce } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IInterventionEntry } from '../../interfaces/intervention-entry-interface';
import { IInterventionRepostiory } from './intervention-db-repository.interface';
import { environment } from '../../environments/environment';
import { IInterventionDbInterface } from '../../interfaces/intervention-db-interface';

interface IInterventionReponse {
    items: IInterventionDbInterface[];
    nextKey: string | undefined;
}

@Injectable({
    providedIn: 'root',
})
export class InterventionDbRepositoryService implements IInterventionRepostiory {

    baseUrl: string = environment.dynamoDbApiConfig.uri;
    interventionEndpoint: string = "interventions"

    constructor(
        private http: HttpClient,
    ) { }


    getInterventionById(interventionId: string): Observable<IInterventionDbInterface | boolean> {
        return this.http.get<IInterventionDbInterface>(`${this.baseUrl}/${this.interventionEndpoint}/${interventionId}`).pipe(
            map(res => {
                return res;
            }),
            catchError(err => {
                console.error(err);
                return of(false);
            })
        );
    }


    getInterventions(
        fromDate?: Date,
        toDate?: Date,
        startKey?: string,
        take?: number,
        bugId?: string,
        customer?: string
    ): Observable<IInterventionDbInterface[]> {
        const params = {
            ...(fromDate && { FromDate: fromDate.toISOString() }),
            ...(toDate && { ToDate: toDate.toISOString() }),
            ...(startKey && { StartKey: startKey }),
            ...(take !== undefined && { Take: take }),  // Allowing 0 as a valid value for take
            ...(bugId && { BugId: bugId }),
            ...(customer && { Customer: customer })
        };

        return this._getInterventionRequest(params).pipe(
            expand((res) => {
                // If there is no nextKey, complete the recursion
                if (!res.nextKey) {
                    return EMPTY;
                }

                // Recursively fetch the next page using the nextKey
                const newParams = {
                    ...params,
                    StartKey: res.nextKey,  // Use nextKey as the new startKey for the next request
                };

                return this._getInterventionRequest(newParams)
            }),
            map(res => res.items), // Extract only the items from the response
            reduce((acc: IInterventionDbInterface[], items) => acc.concat(items), []), // Accumulate all items into a single array
            catchError(err => {
                console.error(err);
                // Return an empty array in case of error
                return of([]);
            })
        );
    }

    createIntervention(intervention: IInterventionEntry): Observable<boolean> {
        return this.http.post(`${this.baseUrl}/interventions`, intervention).pipe(
            map(_ => {
                return true;
            }),
            catchError(err => {
                console.error(err);
                return of(false);
            })
        );
    }

    _getInterventionRequest(params: any): Observable<IInterventionReponse> {
        return this.http.get<IInterventionReponse>(`${this.baseUrl}/${this.interventionEndpoint}`, {
            params: params
        });
    }
}

